<script>

    import { filter } from './filter.js';
    import { map } from './helpers.js';

    export let locations = [];

    function lat( y ){
        // top
        return map( y, 47, 55, 86, 0 );
    }
    function lon( x ){
        // left
        return map( x, 6, 17, 5, 85 );
    }

</script>

<nav class="cities">
    <div class="area">
        {#each locations as location}
            <label style="top:{lat(location.lat)}%;left:{lon(location.lon)}%;" title="{location.city}">
                <input type="checkbox" value="{location.city}" bind:group={$filter} on:change />
                <div class="checkbox"></div>
                <p>{location.city}</p>
            </label>
        {/each}
    </div>
</nav>

<style>

    .cities {
        position: sticky;
        z-index: 50;
        top: 0;
        margin-top: -100vh;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }
    .cities .area {
        width: 100vw;
        height: 100vw;
        position: relative;
    }
    @media (orientation: landscape){
        .cities .area {
            width: 100vh;
            height: 100vh;
        }
    }

    label {
        pointer-events: initial;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;
    }
    .checkbox {
        width: 1em;
        height: 1em;
        border: 2px solid #fff;
        border-radius: 2em;
    }
    input {
        display: block;
        width: 0;
        height: 0;
        opacity: 0;
    }
    input:checked + .checkbox {
        background-color: #fff;
    }

    label {
        position: absolute;
        z-index: 10;
        user-select: none;
        -webkit-user-select: none;
    }

    nav {
        position: sticky;
        top: 0;
    }
    @media (orientation: landscape){
        nav {
            width: 100%;
            height: 100vh;
        }
    }
    @media (max-width: 600px){
        p {
            display: none;
        }
    }

</style>